import styled from 'styled-components';
import { asHeading5 } from '../base/typography';

export const Wrapper = styled.div``;

export const Heading = styled.div`
	${asHeading5};
	margin: 2rem 0;
`;
